// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as PlUtils from "./PlUtils.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as TraitsRow from "common/src/components/TraitsRow.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlLegendLevel from "../components/PlLegendLevel.bs.js";
import * as PositionSquare from "./PositionSquare.bs.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import IconButton from "@mui/material/IconButton";
import OpenInFull from "@mui/icons-material/OpenInFull";
import ArrowForward from "@mui/icons-material/ArrowForward";

var topRow = "flex items-center pb-[3px] mb-3 sm:mb-3 h-[47px] sm:h-auto border-b border-white2";

var expandButton = "text-white1 text-[20px] min-w-8 max-w-8";

var unitsGrid = CssJs.merge([
      "grid justify-center sm:justify-start gap-x-[10px] gap-y-[14px] sm:gap-y-[18px] sm:w-full",
      CssJs.style([
            CssJs.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 6
                      },
                      CssJs.px(42)
                    ]
                  }]),
            T.sm_([CssJs.gridTemplateColumns([{
                          NAME: "repeat",
                          VAL: [
                            "autoFill",
                            CssJs.px(42)
                          ]
                        }])]),
            T.md_([CssJs.gridTemplateColumns([{
                          NAME: "repeat",
                          VAL: [
                            {
                              NAME: "num",
                              VAL: 10
                            },
                            CssJs.px(42)
                          ]
                        }])])
          ])
    ]);

var unitsGridFirstMatch = CssJs.merge([
      unitsGrid,
      CssJs.style([T.md_([CssJs.gridTemplateColumns([{
                          NAME: "repeat",
                          VAL: [
                            {
                              NAME: "num",
                              VAL: 9
                            },
                            CssJs.px(42)
                          ]
                        }])])])
    ]);

var topRowContents = "flex-1 text-sm flex flex-col sm:flex-row sm:items-center px-1 pr-2 sm:pr-1 overflow-hidden font-montserrat font-medium";

var Styles = {
  topRow: topRow,
  expandButton: expandButton,
  unitsGrid: unitsGrid,
  unitsGridFirstMatch: unitsGridFirstMatch,
  topRowContents: topRowContents
};

function PlMatchSummary$Inner(Props) {
  var firstMatch = Props.firstMatch;
  var heroParticipant = Props.heroParticipant;
  var onShowDetails = Props.onShowDetails;
  var onHoverMatch = Props.onHoverMatch;
  var match = React.useState(function () {
        return false;
      });
  var setHovered = match[1];
  var hovered = match[0];
  var basePath = CdnAtom.usePath(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var set = TftSet.use(undefined);
  var firstMatch$1 = firstMatch && heroParticipant.info.units.length < 10;
  var traits = Belt_Array.keepMap(heroParticipant.info.traits, (function (t) {
          if (t.currentTier > 0) {
            return [
                    t.name,
                    t.currentTier
                  ];
          }
          
        }));
  var chosenTraits = React.useMemo((function () {
          return PlUtils.getHeadlinerTraits(heroParticipant.info, set);
        }), [
        heroParticipant,
        set
      ]);
  React.useEffect((function () {
          var timeoutId = {
            contents: undefined
          };
          if (hovered) {
            timeoutId.contents = Caml_option.some(setTimeout((function (param) {
                        return Curry._1(onHoverMatch, heroParticipant.id);
                      }), 100));
          }
          return (function (param) {
                    var timeoutId$1 = timeoutId.contents;
                    if (timeoutId$1 !== undefined) {
                      clearTimeout(Caml_option.valFromOption(timeoutId$1));
                      return ;
                    }
                    
                  });
        }), [
        hovered,
        heroParticipant.id
      ]);
  var adjPlacement = heroParticipant.queueId === 1160 ? (heroParticipant.info.placement + 1 | 0) / 2 | 0 : heroParticipant.info.placement;
  var borderColor;
  switch (adjPlacement) {
    case 1 :
        borderColor = "border-legendary-2";
        break;
    case 2 :
        borderColor = "border-epic-2";
        break;
    case 3 :
        borderColor = "border-rare-2";
        break;
    case 4 :
        borderColor = "border-uncommon-2";
        break;
    default:
      borderColor = "border-common-2";
  }
  var borderl = adjPlacement <= 4 ? "border-l-[3px] " : "border-l-2";
  var match$1 = heroParticipant.rankBefore;
  var match$2 = heroParticipant.rankAfter;
  var tmp;
  if (match$1 !== undefined && match$2 !== undefined) {
    var afterLp = match$2[1];
    var afterDiv = match$2[0];
    var beforeLp = match$1[1];
    var beforeDiv = match$1[0];
    var lpDiff = (LpChartUtils.divisionToBase(afterDiv, set) + afterLp | 0) - (LpChartUtils.divisionToBase(beforeDiv, set) + beforeLp | 0) | 0;
    tmp = lpDiff > 0 && heroParticipant.info.placement > 4 || lpDiff < 0 && heroParticipant.info.placement < 5 ? null : React.createElement(Tooltip.make, {
            title: React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", undefined, LpChartUtils.divisionToShortName(beforeDiv) + " " + String(beforeLp) + "LP"), React.createElement("div", {
                      className: "px-[3px] pb-[2px]"
                    }, React.createElement(ArrowForward, {
                          fontSize: "inherit"
                        })), React.createElement("div", undefined, LpChartUtils.divisionToShortName(afterDiv) + " " + String(afterLp) + "LP")),
            children: React.createElement("div", undefined, (
                  lpDiff > 0 ? "+" : T.enDash
                ) + String(Math.abs(lpDiff)) + "LP")
          });
  } else {
    tmp = null;
  }
  var boardValue = String(PlUtils.calcBoardValue(heroParticipant.info.units, set));
  var augments = heroParticipant.info.augments;
  var tmp$1;
  if (augments !== undefined) {
    var rangeStart = augments.length === 2 && heroParticipant.info.lastRound >= 20 ? -1 : 0;
    tmp$1 = Belt_Array.map(Belt_Array.range(rangeStart, rangeStart + 2 | 0), (function (idx) {
            var augId = Belt_Array.get(augments, idx);
            if (augId !== undefined) {
              return React.createElement(AugmentImage.make, {
                          augId: Data.encodeAugmentId(augId),
                          size: 30,
                          sizeMd: 36,
                          key: augId
                        });
            } else {
              return React.createElement("div", {
                          className: "w-[30px] md:w-[36px]"
                        });
            }
          }));
  } else {
    tmp$1 = null;
  }
  return React.createElement(ButtonBase, {
              component: "div",
              classes: {
                root: "w-full cursor-auto"
              },
              disableRipple: screenSize < 5,
              children: React.createElement("div", {
                    className: "w-full overflow-hidden px-[6px] py-2 sm:py-2 sm:px-3 border-solid " + borderl + " " + borderColor,
                    onClick: (function (param) {
                        if (screenSize >= 5) {
                          return Curry._1(onShowDetails, heroParticipant.id);
                        }
                        
                      }),
                    onMouseLeave: (function (param) {
                        return Curry._1(setHovered, (function (param) {
                                      return false;
                                    }));
                      }),
                    onMouseOver: (function (param) {
                        return Curry._1(setHovered, (function (param) {
                                      return true;
                                    }));
                      })
                  }, React.createElement("div", {
                        className: topRow
                      }, React.createElement("div", {
                            className: "flex items-center sm:hidden pl-1 gap-3 pr-2 sm:pr-3"
                          }, React.createElement(PositionSquare.make, {
                                size: 32,
                                pl: heroParticipant.info.placement,
                                queueId: heroParticipant.queueId
                              }), React.createElement(PlLegendLevel.make, {
                                companionId: heroParticipant.info.companionId,
                                level: heroParticipant.info.level
                              })), React.createElement("div", {
                            className: topRowContents
                          }, React.createElement("div", {
                                className: "flex items-center"
                              }, React.createElement("div", {
                                    className: "text-[13px] sm:text-[14px] flex items-center font-medium font-semibold truncate"
                                  }, PlUtils.queueName(heroParticipant.queueId)), React.createElement("div", {
                                    className: "ml-auto flex items-center pl-3 gap-3 sm:gap-4"
                                  }, tmp, React.createElement(Tooltip.make, {
                                        title: boardValue + " final board gold value",
                                        children: React.createElement("div", {
                                              className: "flex items-center"
                                            }, boardValue, React.createElement("img", {
                                                  className: "ml-[2px]",
                                                  height: "14",
                                                  src: basePath + "/general/gold.png",
                                                  width: "14"
                                                }))
                                      }), React.createElement(Tooltip.make, {
                                        title: String(heroParticipant.info.totalDamageToPlayers) + " damage dealt to players",
                                        children: React.createElement("div", {
                                              className: "flex items-center"
                                            }, String(heroParticipant.info.totalDamageToPlayers), React.createElement("img", {
                                                  className: "ml-[2px]",
                                                  height: "14",
                                                  src: basePath + "/general/announce_icon_combat.png",
                                                  width: "14"
                                                }))
                                      }), React.createElement(Tooltip.make, {
                                        title: "Round eliminated",
                                        children: React.createElement("div", {
                                              className: "flex-shrink-0"
                                            }, heroParticipant.queueId === 1130 ? T.renderHyperrollStageNumber(heroParticipant.info.lastRound) : T.renderStageNumber(heroParticipant.info.lastRound))
                                      }))), React.createElement(TraitsRow.make, {
                                traits: traits,
                                className: "ml-auto",
                                chosenTraits: chosenTraits
                              }))), React.createElement("div", {
                        className: "flex justify-center items-center pb-1 md:pb-[6px]"
                      }, React.createElement("div", {
                            className: "hidden sm:flex items-center pb-[2px] pl-2 pr-5 gap-5"
                          }, React.createElement(PositionSquare.make, {
                                pl: heroParticipant.info.placement,
                                queueId: heroParticipant.queueId
                              }), React.createElement(PlLegendLevel.make, {
                                companionId: heroParticipant.info.companionId,
                                level: heroParticipant.info.level
                              })), React.createElement("div", {
                            className: "flex items-center flex-col md:flex-row md:pl-[2px] pr-4 sm:pr-[10px] md:pr-4 flex-shrink-0 mt-[3px] sm:mt-[6px] md:mt-0 gap-1 md:gap-2"
                          }, tmp$1), React.createElement("div", {
                            className: firstMatch$1 ? unitsGridFirstMatch : unitsGrid
                          }, Belt_Array.mapWithIndex(Belt_Array.keep(heroParticipant.info.units, (function (u) {
                                      return ![
                                                "TFT_TrainingDummy",
                                                "TFT7_TrainerDragon",
                                                "TFT7_JadeStatue",
                                                "TFT9_THex",
                                                "TFT12_Yuumi",
                                                "TFT_ElderDragon",
                                                "TFT12_WinterStatue"
                                              ].includes(u.id);
                                    })), (function (idx, u) {
                                  var unitId = Data.fixId(u.id);
                                  try {
                                    return React.createElement(UnitImageExtended.make, {
                                                size: 42,
                                                unitId: unitId,
                                                starLevel: u.tier,
                                                items: u.items2,
                                                unfilteredItems: true,
                                                key: String(idx)
                                              });
                                  }
                                  catch (exn){
                                    return null;
                                  }
                                }))), React.createElement("div", {
                            className: "hidden sm:block ml-[10px] md:ml-3 mr-1"
                          }, firstMatch$1 ? React.createElement("div", {
                                  className: "ml-auto"
                                }, React.createElement(Button, {
                                      classes: {
                                        root: "px-[6px]"
                                      },
                                      endIcon: React.createElement(OpenInFull, {
                                            fontSize: "inherit",
                                            color: "inherit"
                                          }),
                                      onClick: (function (param) {
                                          return Curry._1(onShowDetails, heroParticipant.id);
                                        }),
                                      variant: "text",
                                      color: "inherit",
                                      children: "Lobby"
                                    })) : React.createElement(IconButton, {
                                  classes: {
                                    root: expandButton
                                  },
                                  onClick: (function (param) {
                                      return Curry._1(onShowDetails, heroParticipant.id);
                                    }),
                                  children: React.createElement(OpenInFull, {
                                        fontSize: "inherit",
                                        color: "inherit"
                                      })
                                }))))
            });
}

var make = React.memo(PlMatchSummary$Inner);

var Inner = {
  make: make
};

function PlMatchSummary(Props) {
  var firstMatch = Props.firstMatch;
  var heroParticipant = Props.heroParticipant;
  var onShowDetails = Props.onShowDetails;
  var onHoverMatch = Props.onHoverMatch;
  var el = React.createElement(make, {
        firstMatch: firstMatch,
        heroParticipant: heroParticipant,
        onShowDetails: onShowDetails,
        onHoverMatch: onHoverMatch
      });
  var set = TftSet.use(undefined);
  if (heroParticipant.queueId === 6110) {
    if (set === 140 || set === 14) {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set101 */11, el, undefined));
    } else {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set56 */9, el, undefined));
    }
  } else if (heroParticipant.queueId === 6100) {
    return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set46 */10, el, undefined));
  } else if (heroParticipant.queueId === 6000) {
    return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set36 */8, el, undefined));
  } else {
    return el;
  }
}

var make$1 = React.memo(PlMatchSummary);

export {
  Styles ,
  Inner ,
  make$1 as make,
  
}
/* unitsGrid Not a pure module */
